import { faUserCog, faUserTie, faUsers, faEnvelope, faBuilding, faBriefcase, faCommentDots, faClock, faFileAlt,
  faCalendarAlt, faCommentAlt } from '@fortawesome/free-solid-svg-icons';
import { appPath } from './index';

export const adminNavMenuLinks = [
  {
    to: `/${appPath}/dashboard`,
    icon: faCalendarAlt,
    title: 'Dashboard'
  },
  {
    to: `/${appPath}/jobs`,
    icon: faBriefcase,
    title: 'Jobs'
  },
  {
    to: `/${appPath}/companies`,
    icon: faBuilding,
    title: 'Accounts'
  },
  {
    to: `/${appPath}/employers`,
    icon: faUserTie,
    title: 'Contacts'
  },
  {
    to: `/${appPath}/workers`,
    icon: faUsers,
    title: 'Workers'
  },
  {
    to: `/${appPath}/messages`,
    icon: faEnvelope,
    title: 'Messages'
  },
  {
    to: `/${appPath}/interviews`,
    icon: faCommentDots,
    title: 'Interviews'
  },
  // {
  //   to: `/${appPath}/orientations`,
  //   icon: faCommentAlt,
  //   title: 'Phone Screens'
  // },
  // {
  //   to: `/${appPath}/prospects`,
  //   icon: faUsers,
  //   title: 'Prospects'
  // },
  // {
  //   to: `/${appPath}/schedule`,
  //   icon: faClock,
  //   title: 'Schedule'
  // },
  {
    to: `/${appPath}/applicants`,
    icon: faUsers,
    title: 'Applicants'
  },
  {
    to: `/${appPath}/admins`,
    icon: faUserCog,
    title: 'Admins'
  },
  {
    to: `/${appPath}/payroll`,
    icon: faFileAlt,
    title: 'Payroll Runs'
  }
];

export const employerNavMenuLinks = [
  {
    to: `/${appPath}/jobs`,
    title: 'My Jobs'
  },
  {
    to: `/${appPath}/messages`,
    title: 'Messages'
  }
];



// WEBPACK FOOTER //
// ./src/constants/navMenuLinks.js